import React from 'react'

interface PrintIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const PrintIcon: React.FC<PrintIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 24,
  alt = 'Print icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 24'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M18.4 2.25H5.6a.75.75 0 00-.75.75v1.639h14.3V3a.75.75 0 00-.75-.75zM5.6 1a2 2 0 00-2 2v1.668H2a2 2 0 00-2 2v8.222a2 2 0 002 2h1.6V21a2 2 0 002 2h12.8a2 2 0 002-2v-4.11H22a2 2 0 002-2V6.668a2 2 0 00-2-2h-1.6V3a2 2 0 00-2-2H5.6zm14.8 14.64H22a.75.75 0 00.75-.75V6.668a.75.75 0 00-.75-.75H2a.75.75 0 00-.75.75v8.222c0 .414.336.75.75.75h1.6V12h16.8v3.64zM4.85 13.25h14.3V21a.75.75 0 01-.75.75H5.6a.75.75 0 01-.75-.75v-7.75zM7.375 19c0-.345.28-.625.625-.625h6a.625.625 0 110 1.25H8A.625.625 0 017.375 19zM16 15.375H8a.625.625 0 100 1.25h8a.625.625 0 100-1.25z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default PrintIcon
